export default (firstSlug, isMobile) => (tl) => {
  const works = document.querySelector('#works')
  const projects = works.querySelectorAll('.project')

  if (isMobile) {
    tl.staggerFrom(projects, 1, { y: `+=${window.innerHeight}`, opacity: 0 }, 0.2)
    tl.call(() => {
      works.classList.add('anim-finished')
    })
    return
  }

  // desktop anim
  const thumbs = document.querySelector('#thumbs')
  const firstThumb = thumbs.querySelector('.first img')
  const firstProject = works.querySelector(`.${firstSlug}`)
  const h2 = firstProject.querySelector('h2')
  const p = firstProject.querySelector('p')

  tl.from('#thumbs', 0.6, { y: '+=100', opacity: 0 })
  tl.from('#works', 0.8, { x: window.innerWidth, opacity: 0, delay: -0.2 }, 'videoAnim')
  tl.fromTo(firstThumb, 0.8, { opacity: 0.3, delay: -0.2 }, { opacity: 1 }, 'videoAnim')

  tl.fromTo(h2, 0.4, { opacity: 0 }, { opacity: 1 }, '-=0.8')
  tl.fromTo(p, 0.4, { opacity: 0 }, { opacity: 1 }, '-=0.6')

  tl.call(() => {
    const w = thumbs.style.width
    const top = thumbs.style.top
    firstThumb.removeAttribute('style')
    thumbs.removeAttribute('style')
    thumbs.style.width = w
    thumbs.style.top = top
  })
}



// WEBPACK FOOTER //
// ./src/components/worksAnim.js